import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {FlatButton} from '@pb/kit-component-button';

import {
    activePlatformAlertsStateActions,
    activePlatformAlertsStateSelector,
} from '../slices/active-platform-alerts-state.slice';

export const ClearFilters = () => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(activePlatformAlertsStateSelector);

    const clearAllFilters = useCallback(() => {
        dispatch(activePlatformAlertsStateActions.setFilters({}));
    }, [dispatch]);

    return Object.values(cacheKeys.filters).filter(Boolean).length ? (
        <FlatButton
            disabled={false}
            onClick={clearAllFilters}>
            <strong>
                Clear All Filters
            </strong>
        </FlatButton>
    ) : null;
};
